import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Spade, LayoutDashboard, GraduationCap, BarChart3, Trophy, Crown, User, LogOut, Menu, X, RotateCcw } from "lucide-react";

export const Header = () => {
  const { user, logout } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { to: "/dashboard", label: "Dashboard" },
    { to: "/training", label: "Training" },
    { to: "/progress", label: "Progress" },
    { to: "/leaderboard", label: "Leaderboard" },
    { to: "/education", label: "Education" },
    { to: "/hand-replayer", label: "Replayer" },
  ];

  const mobileNavLinks = [
    { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { to: "/training", label: "Training", icon: GraduationCap },
    { to: "/progress", label: "Progress", icon: BarChart3 },
    { to: "/leaderboard", label: "Leaderboard", icon: Trophy },
    { to: "/education", label: "Education", icon: GraduationCap },
    { to: "/hand-replayer", label: "Replayer", icon: RotateCcw },
  ];

  return (
    <header className="glass-header sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-2" data-testid="header-logo">
            <div className="w-8 h-8 rounded-md bg-[#D4AF37] flex items-center justify-center">
              <Spade className="w-5 h-5 text-black" />
            </div>
            <span className="font-semibold text-lg hidden sm:block">PokerMentor</span>
          </Link>

          {user && (
            <nav className="hidden md:flex items-center gap-6">
              {navLinks.map(({ to, label }) => (
                <Link key={to} to={to} className="text-sm font-medium text-neutral-300 hover:text-white transition-colors" data-testid={`nav-${label.toLowerCase()}`}>
                  {label}
                </Link>
              ))}
              {user.is_admin && (
                <Link to="/admin" className="text-sm font-medium text-neutral-300 hover:text-white transition-colors" data-testid="nav-admin">Admin</Link>
              )}
            </nav>
          )}

          <div className="flex items-center gap-4">
            {user ? (
              <>
                {user.is_premium && (
                  <span className="hidden sm:flex items-center gap-1 px-2 py-1 rounded-full premium-gradient text-black text-xs font-semibold">
                    <Crown className="w-3 h-3" /> Premium
                  </span>
                )}
                <Link to="/profile" className="flex items-center gap-2" data-testid="nav-profile">
                  <div className="w-8 h-8 rounded-full bg-[#121212] border border-white/10 overflow-hidden">
                    {user.picture ? <img src={user.picture} alt={user.name} className="w-full h-full object-cover" /> : <User className="w-4 h-4 m-2 text-neutral-400" />}
                  </div>
                </Link>
                <button onClick={logout} className="hidden md:flex items-center gap-1 text-sm text-neutral-400 hover:text-white transition-colors" data-testid="logout-button">
                  <LogOut className="w-4 h-4" />
                </button>
              </>
            ) : (
              <Link to="/login" className="bg-[#D4AF37] text-black font-semibold rounded-md px-4 py-2 text-sm hover:bg-[#B3922A] transition-colors" data-testid="login-button">Sign In</Link>
            )}
            {user && (
              <button onClick={() => setMobileMenuOpen(v => !v)} className="md:hidden p-2" data-testid="mobile-menu-toggle">
                {mobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
              </button>
            )}
          </div>
        </div>

        {user && mobileMenuOpen && (
          <div className="md:hidden border-t border-white/10 py-4">
            <nav className="flex flex-col gap-2">
              {mobileNavLinks.map(({ to, label, icon: Icon }) => (
                <Link key={to} to={to} className="flex items-center gap-2 px-4 py-2 rounded-md hover:bg-white/5" onClick={() => setMobileMenuOpen(false)}>
                  <Icon className="w-4 h-4" /> {label}
                </Link>
              ))}
              {user.is_admin && (
                <Link to="/admin" className="flex items-center gap-2 px-4 py-2 rounded-md hover:bg-white/5" onClick={() => setMobileMenuOpen(false)}>
                  <Crown className="w-4 h-4" /> Admin
                </Link>
              )}
              <button onClick={() => { logout(); setMobileMenuOpen(false); }} className="flex items-center gap-2 px-4 py-2 rounded-md hover:bg-white/5 text-left w-full text-neutral-400">
                <LogOut className="w-4 h-4" /> Logout
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
